module.exports = __webpack_public_path__ + "img/icon_location.548a3004.svg";